import React, { useEffect, useState } from 'react';
import { BaseURL } from '../global/api.global';
import { Modal } from 'reactstrap';

const ViewReportModal = (props: any) => {
    const [modalState, setModalState] = useState(false);
    const { state, vesselId, reportId, modalId } = props;

    useEffect(() => {
        setModalState(state);
    }, [state])

    function removeBodyCss() {
        document.body.classList.add("no_padding");
    }

    function tog_backdrop() {
        setModalState(false);
        removeBodyCss();
    }
    return (
        <Modal
            isOpen={modalState}
            toggle={() => {
                tog_backdrop();
            }}
            backdrop={"static"}
            id={modalId}
            size='xl'
        >
            <div className="modal-header">
                <h5 className="modal-title" id="staticBackdropLabel">
                    View Report
                </h5>
                <button
                    type="button"
                    className="btn-close"
                    onClick={() => {
                        setModalState(false);
                    }}
                    aria-label="Close"
                ></button>
            </div>
            <div className="modal-body">
                <iframe src={`${BaseURL}/noon-report-pdf/${vesselId}/${reportId}/`} width='100%' height='500px' title={`${vesselId}/${reportId}`} />
            </div>
        </Modal>
    )
}

export default ViewReportModal